export enum addLoyaltyOption {
  none,
  noLoyalty,
  hasLoyalty,
}
